/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";
import Str from "shared/components/Str";

const PriceTable = (props) => {
	let firstUnitName;
	let taxRow;
	let unitRow;
	let value;
	const {
		units,
		displayUnitPrice,
		displayPrice,
		displayTax,
		displayTotal,
	} = props.selectedOption;

	let { unitname } = props.product;

	// `unitname` is actually a tuple of unitnames
	const unitNames = unitname;

	const S = props.currencySymbol;

	if (unitNames != null) {
		unitname = unitNames[units === 1 ? 0 : 1];
		firstUnitName = unitNames[0];
	}

	// First Row - subtotal
	// ----------------------------------------------------------------------

	// unit-based items
	if (unitNames != null) {
		const label = `${units} ${unitname}`;
		value = `${S}${displayUnitPrice} / ${firstUnitName}`;
		unitRow = (
			<tr>
				<td className="okpay-price-label okpay-price-unit">{label}</td>
				<td className="okpay-price-value okpay-price-unit">{value}</td>
			</tr>
		);

		// non-unit items
	} else if (displayTax) {
		value = `${S}${displayPrice}`;
		unitRow = (
			<tr>
				<td className="okpay-price-label okpay-price-unit">
					<Str>Subtotal</Str>
				</td>
				<td className="okpay-price-value okpay-price-unit">{value}</td>
			</tr>
		);
	}

	// Second row - tax
	// ----------------------------------------------------------------------

	if (displayTax) {
		value = `${S}${displayTax}`;
		taxRow = (
			<tr>
				<td className="okpay-price-label okpay-price-tax">
					<Str>Tax</Str>
				</td>
				<td className="okpay-price-value okpay-price-tax">{value}</td>
			</tr>
		);
	}

	// And the rest
	// ----------------------------------------------------------------------

	const total = `${S}${displayTotal}`;

	return (
		<table className="okpay-price">
			<tbody>
				{unitRow}
				{taxRow}
				<tr>
					<td className="okpay-price-label okpay-price-total">
						<Str>Total</Str>
					</td>
					<td className="okpay-price-value okpay-price-total">{total}</td>
				</tr>
			</tbody>
		</table>
	);
};

export default PriceTable;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/PriceTable.jsx